<div class="modal-body">
  <button type="button" class="close" ng-click="$dismiss();" style="position: absolute; right: 30px; top: 30px;"><span>&times;</span></button>
  <img ng-src="{{modal.$resolve.image}}" class="img-responsive" />
</div>
